import type { I18nFn } from 'i18n/types/I18nFn';

export type ListingTypeKeys =
  | 'JOB'
  | 'INTERNSHIP'
  | 'VOLOP'
  | 'EVENT'
  | 'ORG'
  | 'USER'
  | 'CANDIDATE'
  | 'IMPORTED';

export function LISTING_TYPE_HUMAN_NAME_MAP(i18n: I18nFn) {
  return {
    JOB: i18n('job'),
    INTERNSHIP: i18n('internship'),
    VOLOP: i18n('volunteer opportunity'),
    EVENT: i18n('event'),
    ORG: i18n('organization'),
    USER: i18n('user'),
    CANDIDATE: i18n('candidate'),
    IMPORTED: i18n('opportunity'),
  };
}

export const getListingTypeHumanName = (
  i18n: I18nFn,
  listing: {
    type: ListingTypeKeys;
  },
) => LISTING_TYPE_HUMAN_NAME_MAP(i18n)[listing.type];
